import React from "react"
import { graphql, Link } from "gatsby"
import { handleFauxClick, isExternal } from "../utils/url"
import formatPagePath from "../utils/format-page-path"
import replaceHyphenation from "../utils/replace-hyphenation"
import CallToAction from "./call-to-action"

export const query = graphql`
  fragment CardsFields on DatoCmsCard {
    id
    model {
      apiKey
    }
    componentId: key
    title
    headline
    cards {
      id
      title
      image {
        alt
        url(imgixParams: { w: "600" })
      }
      linkUrl
    }
    ctaLabel
    ctaLink
    leftAlign
    blurbNode {
      childMarkdownRemark {
        html
      }
    }
  }
`

const formatLink = (link: string): string => {
  return isExternal(link) ? link : formatPagePath(link)
}

const Cards = ({
  componentId,
  headline,
  cards,
  ctaLabel,
  ctaLink,
  blurbNode,
  leftAlign,
}: Queries.CardsFieldsFragment) => {
  return (
    <section id={componentId} className="c-cards o-wrapper o-row">
      {headline && (
        <h2
          className={`c-cards__title c-content-header ${
            leftAlign ? `-left` : ""
          }`}
        >
          {headline}
        </h2>
      )}
      {blurbNode &&
        blurbNode.childMarkdownRemark &&
        blurbNode.childMarkdownRemark.html && (
          <div
            className="c-cards__blurb"
            dangerouslySetInnerHTML={{
              __html: blurbNode.childMarkdownRemark.html,
            }}
          />
        )}
      <div className="c-cards__items">
        {cards &&
          cards.map(item => {
            const image = item.image.url ? item.image.url : ""
            const imageAlt =
              item && item.image && item.image.alt ? item.image.alt : item.title

            const href = item.linkUrl ? formatLink(item.linkUrl) : null
            return (
              <div
                key={item.id}
                className="c-card"
                data-faux-href={href}
                onClick={handleFauxClick}
              >
                <div className="c-card__label">
                  <h3 className="c-heading--e">
                    {item.linkUrl ? (
                      <Link to={href}>{replaceHyphenation(item.title)}</Link>
                    ) : (
                      <>{item.title}</>
                    )}
                  </h3>
                </div>
                <div className="c-card__inner">
                  <img src={image} alt={imageAlt} />
                </div>
              </div>
            )
          })}
      </div>
      {ctaLabel && ctaLink && (
        <div className="c-cards__cta">
          <CallToAction color="outline-dark" url={ctaLink}>
            {ctaLabel}
          </CallToAction>
        </div>
      )}
    </section>
  )
}

export default Cards
